import { DELIVERY_METHOD_CODES } from '@/lib/utils';
import z from 'zod/v4';

export const DeliveryMethodsSchema = z.enum(DELIVERY_METHOD_CODES);

export const DistributionInstructionsSchema = z.array(
  z.array(DeliveryMethodsSchema)
);
